import React from "react"
import Button from "react-bootstrap/lib/Button"

import BubbleCard from "../../ui-components/BubbleCard"

import style from "../index.module.sass"

// ----------------------------------------------------------------------------

function CancelledCard(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div className={style.bubbleContainer}>
      <BubbleCard color="grey">
        <div className={style.inner}>
          <p className={style.alreadyRatedThanks}>
            {I18n.t("pages.orders.show.order_refused_card_title")}
          </p>
          <p className={style.alreadyRatedTitle}>
            {I18n.t("pages.orders.show.order_refused_card_desc")}
          </p>
          <Button bsStyle="primary" className={`${style.contactUs} intercom-launcher`}>
            {I18n.t("pages.orders.show.order_refused_card_btn")}
          </Button>
        </div>
      </BubbleCard>
    </div>
  )
}

// ----------------------------------------------------------------------------

export default CancelledCard
